import {Component, Input, OnInit} from '@angular/core';
import {ExgModalService} from 'exc-controls-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcSecurityService} from 'exc-security-v2';
import {ApplicationService} from '../../services/application.service';

@Component({
  selector: 'app-modal-task-worklist',
  templateUrl: './modal-task-worklist.component.html',
  styles: []
})
export class ModalTaskWorklistComponent extends ExcTranslation implements OnInit {
  @Input()
  data: { worklistData: any[], worklistItem: any } = { worklistData: [] as any[], worklistItem: {} };
  uiModel: any = {
    api_oid: '',
    apiUPT: '',
    apiSequence: 1,
    apiFreigabe: 0,
    apiPruefen: 0,
    apiMonitoring: 0,
    apiCustom: false,
    apiSollDatum: undefined,
    apiPlanDatum: undefined,
    apiIstDatum: undefined,
    apiKommentar: '',
    apiSollDatumLCT: ''
  };
  uiModelDates: any = {
    apiPlanDatum: undefined,
    apiPlanDatumDate: undefined,
    apiPlanDatumTime: undefined,

    apiIstDatum: undefined,
    apiIstDatumDate: undefined,
    apiIstDatumTime: undefined,
  };
  uiModelClone: any;
  // Check the apiFreigabe is set and security token SCHEDULEMGMT is existing
  disableCondition = false;


  constructor(public excRestService: ExcRestService,
              public modal: ExgModalService,
              public enumSvc: EnumerationService,
              public excSecurityService: ExcSecurityService,
              public appSrv: ApplicationService) {
    super();
  }

  ngOnInit(): void {
    this.initialize();
  }

  initialize(): void {
    this.uiModel = this.appSrv.helperObj.clone(this.data.worklistItem);
    this.uiModel.apiSequence = undefined;
    this.initializeDates(this.uiModel.apiIstDatum, this.uiModel.apiPlanDatum);
    this.uiModelClone = this.appSrv.helperObj.clone(this.uiModel);
    if (this.uiModel.apiFreigabe && !this.excSecurityService.isFeatured('SCHEDULEMGMT')){
      this.disableCondition = true;
    }
  }

  initializeDates(apiIstDatum: number, apiPlanDatum: number): void {
    if (apiIstDatum) {
      this.uiModelDates.apiIstDatum = new Date(apiIstDatum);
      this.uiModelDates.apiIstDatumDate =
        this.uiModelDates.apiIstDatum.toLocaleDateString('fr-CA', {year: 'numeric', day: '2-digit', month: '2-digit'});
      this.uiModelDates.apiIstDatumTime =
        this.uiModelDates.apiIstDatum.toLocaleTimeString();
    }
    if (apiPlanDatum) {
      this.uiModelDates.apiPlanDatum = new Date(apiPlanDatum);
      this.uiModelDates.apiPlanDatumDate =
        this.uiModelDates.apiPlanDatum.toLocaleDateString('fr-CA', {year: 'numeric', day: '2-digit', month: '2-digit'});
      this.uiModelDates.apiPlanDatumTime =
        this.uiModelDates.apiPlanDatum.toLocaleTimeString();
    }
  }

  combineDateTime(dateTyp: string, dateValue: any, timeValue: any = '00:00'): void {
    if (dateValue) {
      const date: Date = new Date(dateValue + 'T' + timeValue);

      this.uiModel[dateTyp] = date.toISOString().slice(0, -1);
      this.uiModelDates[dateTyp + 'Date'] = dateValue;
      this.uiModelDates[dateTyp + 'Time'] = timeValue;
    }
  }

  clickedSave(): void {
    const SELF = this;
    if (this.appSrv.helperObj.changed(this.uiModel, this.uiModelClone)
        && (
          !this.isRequired() ||
          SELF.uiModel.apiSollDatum === this.uiModelClone.apiSollDatum
        )
    ) {
      SELF.excRestService.put(SELF.excRestService.computeUrl('ScheduleItemU', {apiID: this.uiModel.apiID})
        ,  this.getUiModel()).subscribe((response: any) => {
        if (response.rtval === 1000) {
          SELF.modal.showToast(SELF.getRessource('Success'), 'md-toast', 'fas fa-check-circle');
          SELF.modal.action(true);
        } else {
          SELF.modal.showToast(SELF.getRessource('Fail'), 'md-toast', 'fas fa-exclamation');
        }
      });
    }
  }

  clickedRelease(): void {
    if (this.excSecurityService.isFeatured('SCHEDULEAPPROVE')) {
      const SELF = this;
      SELF.excRestService.put(SELF.excRestService.computeUrl('ScheduleItemU', {apiID: this.uiModel.apiID})
        , this.getUiModel()).subscribe((response: any) => {
        if (response.rtval === 1000) {
          SELF.modal.showToast(SELF.getRessource('Success'), 'md-toast', 'fas fa-check-circle');
          SELF.modal.action(true);
        } else {
          SELF.modal.showToast(SELF.getRessource('Fail'), 'md-toast', 'fas fa-exclamation');
        }
      });
    }
  }

  clickedDelete(): void {
    const SELF = this;
    if (this.excSecurityService.isFeatured('SCHEDULEDELETE')) {
      SELF.excRestService.delete(
        SELF.excRestService.computeUrl('ScheduleItemD', {apiID: SELF.uiModel.apiID})
        , this.getUiModel()).subscribe((response: any) => {
        if (response.rtval) {
          this.modal.showToast(SELF.getRessource('Success'), 'md-toast', 'fas fa-check-circle');
          this.modal.action(true);
        } else {
          this.modal.showToast(SELF.getRessource('Fail'), 'md-toast', 'fas fa-exclamation');
        }
      });
    }
  }

  clickedCancel(): void {
    const SELF = this;
    SELF.modal.close();
  }

  isRequired(): boolean {
    return this.uiModel.apiSollDatum !== this.uiModelClone.apiSollDatum
      && (!this.uiModel.apiSollDatumLCT || (this.uiModel.apiSollDatumLCT && this.uiModel.apiSollDatumLCT.length < 5));
  }

  getUiModel(): any {
    if (this.uiModel.apiSequence >= 0) {
      this.uiModel.apiSequence = this.data.worklistData[this.uiModel.apiSequence].apiSequence;
    } else if (!this.uiModel.apiSequence) {
      this.uiModel.apiSequence = this.data.worklistItem.apiSequence;
    }
    return this.uiModel;
  }
}
